import React from 'react' // React must be in scope to use JSX

export const JLLServices = {
    "design": {
        id: "design",
        title: "Design",
        serviceDescription: <>
            <p>Weddings, theme parties, product launches, books, brochures, presentations, outdoor signage, stickers – I can help elevate your message and make things exciting for your audience!</p>
            {/*<a href="#services" className="cuteNav"> + see ways you can ↴</a>*/}
        </>,
        serviceImagePaths: [
            {
                id: "aww-place-settings-01",
                desktopPath: "/images/pm_aww/pm_aww_placesettings_03.jpg",
                mobilePath: "/images/pm_aww/pm_aww_placesettings_01.jpg"
            }/* ,
           {
                id: "wedding-stationery",
                desktopPath: "/images/pm_aww/pm_aww_placesettings_05.jpg"
            },
            {
                id: "aww-place-settings-07",
                desktopPath: "/images/pm_aww/pm_aww_placesettings_07.jpg",
                mobilePath: "/images/pm_aww/pm_aww_placesettings_07_mobile.jpg"
            }*/,
            {
                id: "trivia-night-indhu",
                desktopPath: "/images/trivia/trivia_indhu_desktop.jpg",
                mobilePath: "/images/trivia/trivia_indhu_mobile.jpg",
            }/*,
            {
                id: "trivia-night-indhu",
                desktopPath: "/images/trivia/trivia_indhu_scorecards_desktop.jpg",
                mobilePath: "/images/trivia/trivia_indhu_scorecards_mobile.jpg",
            }*/,
            {
                id: "whistledown-papers",
                desktopPath: "/images/whistledown_papers_04.jpg",
                mobilePath: "/images/whistledown_papers_mobile_fix.jpg"
            },
            // {
            //    id: "crown-signature-celine-firm",
            //   desktopPath: "/images/crown/crown_signature_celine_firm.jpg"
            // }, 
            {
                id: "beautyrest-launch-entry",
                desktopPath: "/images/crown/beautyrest_launch_samplebox.jpg"
            },
            {
                id: "crown-signature-teaser",
                desktopPath: "/images/crown/crown_signature_teaser_01.jpg",
                mobilePath: "/images/crown/crown_signature_teaser_01_mobile.jpg"
            },
            {
                id: "unimelb-study-oyl",
                desktopPath: "/images/unimelb/unimelb_study_oyl.jpg",
                mobilePath: "/images/unimelb/unimelb_study_oyl_mobile.jpg"
            },
            {
                id: "unimelb-doc-oyl",
                desktopPath: "/images/unimelb/unimelb_doc_oyl.jpg"
            },
            {
                id: "pollen-guide-excerpts",
                desktopPath: "/images/pollen/pollen_forecast.jpg",
                mobilePath: "/images/pollen/pollen_forecast_mobile.jpg"
            },
            {
                id: "crown-6b&b-booklet",
                desktopPath: "/images/crown/crown_6b&b_booklet.jpg"
            },
            {
                id: "sm-cocoon",
                desktopPath: "/images/pm_gen/services_smcocoon_sb_03.jpg"
            }
        ],
        serviceItems: [

            {
                id: "graphic-design",
                serviceItemTitle: "Graphic Design",
                serviceItemDescription: "World-building, narrative through design, etc."
            },
            {

                id: "editorial-design",
                serviceItemTitle: "Editorial Design",
                serviceItemDescription: "Are you an author or publisher looking for an illustrator?",
            },
            {
                id: "event-marketing-collateral",
                serviceItemTitle: "Event & Marketing Collateral",
                serviceItemDescription: "World-building, narrative through design, etc."
            },
            {
                id: "brand-development",
                serviceItemTitle: "Brand Development",
                serviceItemDescription: "World-building, narrative through design, etc."
            },
            {
                id: "responsive-web-design",
                serviceItemTitle: "Responsive Web Design",
                serviceItemDescription: "Creating new ways to ?"
            },
            {
                id: "interaction-design",
                serviceItemTitle: "UX/UI Interaction Design",
                serviceItemDescription: "Creating new ways to ?"
            }
        ]
    },
    "illustration": {
        id: "illustration",
        title: "Illustration",
        serviceDescription: "My earliest passion! If you have a story to tell – a book, an album, a game – big or small, get in touch if you're feeling inspired.",
        //serviceTestimonial: "\"Jon’s attention to detail and the passion he puts into every page, and every stroke is unmatched! Every time I revisit his work, I find something new!\" — Anonymous",
        serviceImagePaths: [
            {
                id: "aoh",
                desktopPath: "/images/prints/AoH_PrintsHeader_DSC_0316.jpg"
            }, {
                id: "apaaf-butterflies",
                desktopPath: "/images/apaaf/apaaf_butterflies_split.jpg",
                mobilePath: "/images/apaaf/apaaf_butterflies_mobile.jpg"
            },
            {
                id: "tdg-sketches",
                desktopPath: "images/tdg/tdg_sketches2.jpg"
            },
            {
                id: "tdg-sybils-01",
                desktopPath: "/images/sybil_01_desktop.jpg",
                mobilePath: "/images/sybil_01_mobile.jpg",
            },
            {
                id: "tdg-sybils-02",
                desktopPath: "/images/sybil_02_desktop.jpg",
                mobilePath: "/images/sybil_02_mobile.jpg",
            },

            {
                id: "apaaf-search",
                desktopPath: "/images/apaaf/apaaf_search.jpg"
            },
            {
                id: "apaaf-snake",
                desktopPath: "/images/apaaf/apaaf_snake_print.jpg"
            },
            {
                id: "suspiria",
                desktopPath: "/images/studies/suspiria_sabbath.jpg",
                mobilePath: "/images/studies/suspiria_sabbath_mobile.jpg"
            },

            {
                id: "bml",
                desktopPath: "/images/prints/BML_PrintsHeader_DSC_0386.jpg"
            },
            {
                id: "sb_201127",
                desktopPath: "/images/studies/hamilton_enough.jpg",
                mobilePath: "/images/studies/hamilton_enough_mobile.jpg"
            },
            {
                id: "wartide",
                desktopPath: "/images/wartide/wartide_apstaff_large.jpg"
            }
        ],
        serviceItems: [
            {
                id: "book-illustration",
                serviceItemTitle: "Book Illustration",
                serviceItemDescription: "should these really change??"
            },
            {
                id: "concept-art",
                serviceItemTitle: "Concept Art"
            },
            {
                id: "boardgame-art",
                serviceItemTitle: "Board / Card Game Art",
                serviceItemDescription: "sadasdasdasdsad"
            },
            {
                id: "album-cover-art",
                serviceItemTitle: "Album Cover Art",
                serviceItemDescription: "asdsadadasdasdasdasdasdasdsdasdasdasdasd asd sa da asd asdasdsadasd a asd asd asdasdad ad as dasd asd ad ad ad"
            },
            {
                id: "character-art",
                serviceItemTitle: "Character Art",
                serviceItemDescription: "asdsadadasdasdasdasdasdasdsdasdasdasdasd asd sa da asd asdasdsadasd a asd asd asdasdad ad as dasd asd ad ad ad"
            },
            {
                id: "decorative-illustration",
                serviceItemTitle: "Decorative Illustration",
                serviceItemDescription: "A? A/  A/d /aD/a?  / ? /a /"
            },
            {
                id: "vector-illustration",
                serviceItemTitle: "Vector Illustration",
                serviceItemDescription: "A? A/  A/d /aD/a?  / ? /a /"
            }
        ]
    },
    /*"print-digital": {
        id: "print-digital",
        title: "Print / Digital",
        serviceDescription:
            "I believe great work is a product of the labour of many. But not everyone can afford a whole team or agency. I'm very fortunate to have a diverse skillset, and hands on experience with a range of media and production methods that enable me to provide solutions for those who need it. This is an incomplete list of all the things I can help with.",
        // "When engaging designers, a lot of clients are left with a great new look, but don't know where to go when it comes print time. I have many years' experience with prepress and print production across all kinds of media (paper, acrylic, vinyl, fabric, wood, etc.) to make your project real. \n \n On the flip side, I have a tonne of digital experience – including UI/UX design, responsive web design, programming, audio/video editing."
        serviceImagePaths: [

            {
                id: "signature-evie",
                desktopPath: "/images/crown/crown_signature_evie2.jpg"
            },
            {
                id: "a-poem-about-a-frog",
                desktopPath: "/images/apaaf_cover_photo_01.jpg",
                mobilePath: "/images/apaaf_search_photo_01.jpg",
            },
            {
                id: "signature-raw-materials",
                desktopPath: "/images/crown/crown_signature_rawmaterials.jpg"
            },
            {
                id: "sm-cocoon",
                desktopPath: "/images/pm_gen/services_smcocoon_sb_03.jpg"
            },

            {
                id: "bestfurn-daisy",
                desktopPath: "/images/bestfurn/bf_daisy.jpg"
            }
        ],
        serviceItems: [
            {
                id: "prepress",
                serviceItemTitle: "Prepress",
                serviceItemImagePath: ""
            },
            {
                id: "large-format-print",
                serviceItemTitle: "Large Format Print",
                serviceItemImagePath: ""
            },
            {
                id: "offset-digital-print",
                serviceItemTitle: "Offset & Digital Print",
                serviceItemImagePath: ""
            },
            {
                id: "cnc-router-cutting",
                serviceItemTitle: "CNC Router Cutting"
            },
            {
                id: "specialty-media",
                serviceItemTitle: "Specialty Media"
            },
            {
                id: "foil-scodix",
                serviceItemTitle: "Foiling & SCODIX"
            },
            {
                id: "embroidery",
                serviceItemTitle: "Embroidery"
            },
            {
                id: "embossing-debossing",
                serviceItemTitle: "Embossing / Debossing"
            },
            {
                id: "fabric-print-dye-sublimation",
                serviceItemTitle: "Fabric Print / Dye Sublimation"
            },
            {
                id: "sav-vinyl-decals",
                serviceItemTitle: "SAV Window / Wall Decals"
            },
            {
                id: "pullup-banners",
                serviceItemTitle: "Pull Up Banners"
            },
            {
                id: "flags",
                serviceItemTitle: "Flags"
            },
            {
                id: "marquees",
                serviceItemTitle: "Marquees"
            },
            {
                id: "a-frames",
                serviceItemTitle: "A-Frame Signage"
            },
            {
                id: "fabric-frames",
                serviceItemTitle: "Fabric Frames"
            },
            {
                id: "acrylic-perspex",
                serviceItemTitle: "Acrylic & Perspex"
            },
            {
                id: "audio-video-editing",
                serviceItemTitle: "Audio / Video Editing"
            },
            {
                id: "image-retouching",
                serviceItemTitle: "Image Retouching"
            },
            {
                id: "edm-socials",
                serviceItemTitle: "EDM & Socials"
            }
        ]
    },*/
    "events": {
        id: "events",
        title: "Events",
        serviceDescription: <p>Looking to elevate your next social event? You don't need to choose between making it professional, personal, or affordable. Whether you're planning a wedding, launching a new product, or organising with your community – let's make it happen!</p>,
        // "There's nothing I enjoy more than lending special occasions an elevated, professional touch. Whether it's for weddings, theme parties, trivia nights – give your day / night the pomp it deserves."
        serviceImagePaths: [
            {
                id: "trivia-night-indhu",
                desktopPath: "/images/trivia/trivia_indhu_desktop.jpg",
                mobilePath: "/images/trivia/trivia_indhu_mobile.jpg",
            },
            {
                id: "whistledown-papers",
                desktopPath: "/images/whistledown_papers.jpg",
                mobilePath: "/images/whistledown_papers_mobile.jpg",
            }, {
                id: "wedding-stationery",
                desktopPath: "/images/pm_aww/pm_aww_placesettings_06.jpg"
            }
        ],
        serviceItems: [
            {
                id: "theme-parties", serviceItemTitle: "Theme Parties",
            },
            {
                id: "weddings", serviceItemTitle: "Weddings",
            },
            {
                id: "trivia-nights", serviceItemTitle: "Trivia Nights",
            },
            {
                id: "hens-nights", serviceItemTitle: "Hens Nights",
            },
            {
                id: "stag-dos", serviceItemTitle: "Stag Dos",
            },
            {
                id: "product-launches", serviceItemTitle: "Product Launches",
            },
            {
                id: "theme-parties", serviceItemTitle: "Community Action",
            }
        ]
    }
}